import axios from 'axios'
import { useAuthStore } from '@/stores/auth'
import { mockApis, mockStats, Apis } from './constants/api.js'
import { delay, delayTimes } from './constants/common.js'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api'

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000
})

// Interceptor para adicionar token de autenticação
apiClient.interceptors.request.use((config) => {
  const authStore = useAuthStore()
  if (authStore.token) {
    config.headers.Authorization = `Bearer ${authStore.token}`
  }
  return config
})



export const getApiStats = async () => {
  await delay(delayTimes.medium)
  return mockStats
}


export const getAllApis = async () => {
  await delay(delayTimes.slow)
  return mockApis
}

export const getApiById = async (id) => {
  await delay(delayTimes.medium)
  return mockApis.find(api => api.id === id)
}

export const uploadSwaggerFile = async (data) => {
  await delay(delayTimes.upload)
  console.log('Upload simulado:', data)
  return { success: true, id: Date.now().toString() }
}

export const searchApis = async (query) => {
  await delay(600)
  return mockApis.filter(api => 
    api.name.toLowerCase().includes(query.toLowerCase()) ||
    api.description.toLowerCase().includes(query.toLowerCase())
  )
}